module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "image3"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    attrs: {
      "href": "#/035imagecredits#page10",
      "title": "Link target outside of Sample"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-10.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "part",
    attrs: {
      "id": "part1"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#parti"
    }
  }, [_vm._v("PART I:"), _c('br'), _vm._v("HOW TO HAVE AN ORIGIN"), _c('br'), _vm._v("WITHOUT A PLANET BLOWING"), _c('br'), _vm._v("UP, PARENTS MURDERED,"), _c('br'), _vm._v("RADIOACTIVE SPIDER BITES,"), _c('br'), _vm._v("COSMIC RAYS, GAMMA RAYS,"), _c('br'), _vm._v("WHITE DWARF STARS, ALIENS"), _c('br'), _vm._v("CRASH-LANDING, A MAGIC"), _c('br'), _vm._v("WORD, A MAGIC HAMMER,"), _c('br'), _vm._v("OR A SUPER SERUM")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7495931a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006part1.vue
// module id = 72
// module chunks = 0